export default "__VITE_ASSET__DsZG0pAY__"